import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { AdminLayout } from "@/components/admin/AdminLayout";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function AdminSettingsPage() {
  const [items, setItems] = useState([]);
  const [key, setKey] = useState("");
  const [value, setValue] = useState("");
  const load = () => api.get("/admin/settings").then(r => setItems(r.data || [])).catch(() => toast.error("Owner-only"));
  useEffect(() => { load(); }, []);
  const save = async () => {
    try {
      let parsed = value;
      try { parsed = JSON.parse(value); } catch { /* keep string */ }
      await api.put("/admin/settings", { key, value: parsed });
      toast.success("Saved");
      setKey(""); setValue("");
      load();
    } catch (e) { toast.error("Save failed", { description: e?.response?.data?.detail || "" }); }
  };
  return (
    <AdminLayout>
      <div className="kicker">Owner only</div>
      <h1 className="mt-1 font-serif text-3xl font-semibold">Settings</h1>
      <Card className="mt-6 p-6">
        <div className="kicker">Upsert setting</div>
        <div className="mt-3 grid gap-3">
          <Input placeholder="key" value={key} onChange={e => setKey(e.target.value)} className="h-11 font-mono" />
          <Textarea placeholder='value (JSON or string)' rows={3} value={value} onChange={e => setValue(e.target.value)} />
        </div>
        <div className="mt-3"><Button onClick={save} disabled={!key} className="bg-[color:var(--coh-ink)] text-white">Save</Button></div>
      </Card>
      <div className="mt-6 space-y-3">
        {items.length === 0 && <Card className="p-6 text-sm text-muted-foreground">No settings yet.</Card>}
        {items.map((s) => (
          <Card key={s.key} className="p-6">
            <div className="font-mono text-sm font-medium">{s.key}</div>
            <pre className="mt-2 text-xs bg-secondary p-3 rounded">{JSON.stringify(s.value, null, 2)}</pre>
            <div className="mt-1 text-xs text-muted-foreground">Updated {new Date(s.updated_at).toLocaleString()}</div>
          </Card>
        ))}
      </div>
    </AdminLayout>
  );
}
